import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    id: 1,
    text: '“Etravo made our honeymoon trip unforgettable! From booking our dream resort in the Maldives to arranging candlelight dinners and spa sessions, every detail was taken care of. We didn’t have to worry about a thing and could just focus on making memories.”',
    author: 'Mr. Arjun Mehra',
    designation: 'Traveler, India',
    image: 'images/resource/author-1.jpg',
  },
  {
    id: 2,
    text: '“Thanks to Etravo, our family vacation across Europe was perfectly organized. From smooth airport pickups in Paris to guided tours in Rome and hotel stays in Switzerland, everything was beyond expectations. The kids especially loved the surprise activities Etravo arranged!”',
    author: 'Ms. Priya Kapoor',
    designation: 'Travel Enthusiast, India',
    image: 'images/resource/author-2.jpg',
  },
  {
    id: 3,
    text: '“I’ve booked multiple trips with Etravo, and each time they’ve delivered consistent quality. They offer great package deals, excellent support, and even helped me reschedule a flight last minute without extra charges. They truly put the traveler first.”',
    author: 'Mr. Rohan Verma',
    designation: 'Frequent Flyer, India',
    image: 'images/resource/author-3.jpg',
  },
  {
    id: 4,
    text: '“Our corporate retreat to Bali wouldn’t have been a success without Etravo. They managed transportation, hotel arrangements, conference space, and even organized local cultural experiences for our team. Everyone returned refreshed and impressed with the smooth planning.”',
    author: 'Mr. Amit Sharma',
    designation: 'HR Executive, GlobalTech India',
    image: 'images/resource/author-4.jpg',
  },
  {
    id: 5,
    text: '“As a solo traveler, I used to be nervous about managing everything myself, but Etravo gave me peace of mind. From day one, they were there with itinerary updates, local contacts, and even checked in with me during my trip to ensure I was safe and enjoying my time.”',
    author: 'Ms. Ananya Rao',
    designation: 'Solo Traveler, India',
    image: 'images/resource/author-5.jpg',
  },
  {
    id: 6,
    text: '“Etravo helped us discover hidden gems in Southeast Asia. We didn’t just visit tourist spots — we experienced authentic village life, hiked through breathtaking landscapes, and enjoyed local cuisine with personal guides. It felt like a true adventure tailored just for us.”',
    author: 'Mr. Karan Deshmukh',
    designation: 'Adventure Seeker, India',
    image: 'images/resource/author-6.jpg',
  },
];


const Testimonialabout = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (

<>
   <section
      className="page-title"
      style={{ backgroundImage: 'url(images/background/3.jpg)' }}
    >
      <div className="auto-container">
        <h1>Testimonials</h1>
        <div className="bread-crumb-outer">
         
        </div>
      </div>
    </section>



    <section
      className="testimonial-section"
      style={{ backgroundImage: 'url(images/background/1.jpg)' }}
    >
      <div className="auto-container">
        <div className="content-container">
          <div className="sec-title">
            <div className="inner-title-box">
              <h2>WHAT PEOPLE SAY</h2>
              <h4 className="rotate-title">TESTIMONIALS</h4>
            </div>
          </div>
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div className="testimonial-block" key={testimonial.id}>
                <div className="inner-box">
                  <div className="quote-icon">
                    <span className="icon flaticon-left-quote"></span>
                  </div>
                  <div className="text">{testimonial.text}</div>
                  <div className="author-info">
                   
                    <h3>{testimonial.author}</h3>
                    <div className="designation">{testimonial.designation}</div>
                  </div>
                  <div className="carousel-number">
                    {index + 1} <span>/ {testimonials.length.toString().padStart(2, '0')}</span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
</>
  );
};

export default Testimonialabout;
